export const RULE_TYPES = ['Email', 'Role', 'BrokerFirm', 'BrokerChain', 'Country'] as const;
export type FeatureFlagRuleType = (typeof RULE_TYPES)[number];

export const RULE_OPERATORS = ['In', 'NotIn'] as const;
export type FeatureFlagRuleOperator = (typeof RULE_OPERATORS)[number];

export interface FeatureFlagRule {
    id: number;
    priority: number;
    ruleType: FeatureFlagRuleType;
    operator: FeatureFlagRuleOperator;
    values: string[];
    resultEnabled: boolean;
    resultVariant: string | null;
}

export interface FeatureFlag {
    key: string;
    description: string | null;
    defaultEnabled: boolean;
    variants: string[];
    defaultVariant: string | null;
    updatedAt: string;
    updatedBy: string;
    rules: FeatureFlagRule[];
}

export interface FeatureFlagRuleInput {
    id?: number | null;
    priority: number;
    ruleType: FeatureFlagRuleType;
    operator: FeatureFlagRuleOperator;
    values: string[];
    resultEnabled: boolean;
    resultVariant: string | null;
}

export interface CreateFeatureFlagInput {
    key: string;
    description: string | null;
    defaultEnabled: boolean;
    rules: FeatureFlagRuleInput[];
}

export interface UpdateFeatureFlagInput {
    description: string | null;
    defaultEnabled: boolean;
    defaultVariant: string | null;
    rules: FeatureFlagRuleInput[];
}

export interface BrokerOption {
    id: number;
    name: string;
}

export interface CountryOption {
    code: string;
    name: string;
}

export interface FeatureFlagOptions {
    roles: string[];
    countries: CountryOption[];
    brokerFirms: BrokerOption[];
    brokerChains: BrokerOption[];
}
